import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import TelefoneBrasileiroInput from "react-telefone-brasileiro"
import { useEnergiaIdentificacaoContext } from '../../../context/energiaIdentificacaoContext'

import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'


const Modal = (props) => {

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const adesao_institucional_id = props.adesao_institucional_id
    const energia_id = props.energia_id

    const { energiaResponsavel_id, setEnergiaResponsavel_id } = useEnergiaIdentificacaoContext()
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [telefone, setTelefone] = useState('')



    function consultaResponsavelDet() {


        if (energiaResponsavel_id) {


            api.get(`energiaResponsavelListaUm/${energiaResponsavel_id}`).then((result) => {

                var data = result.data[0]

                setNome(data.nome)
                setEmail(data.email)
                setTelefone(data.telefone)

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }


    function salva() {

        if (nome == '') {

            window.toastr.error('<b>Nome</b> não pode ficar em branco!')
            return false;

        }


        if (telefone == '') {

            window.toastr.error('<b>Telefone</b> não pode ficar em branco!')
            return false;

        }


        if (email == '') {

            window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
            return false;

        }



        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            nome: nome.toUpperCase(),
            email: email.toLocaleLowerCase(),
            telefone: telefone,

        }

        console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {



                    if (energiaResponsavel_id) {

                        //console.log('put')

                        api.put(`energiaResponsavel/${energiaResponsavel_id}`, dataPost).then(() => {
    
                            //setShow(false)
                            window.$('#modalEnergiaIdentificacao').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaResponsavel', dataPost).then(() => {

                           
                            //setShow(false)
                            window.$('#modalEnergiaIdentificacao').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }




    function apagaResponsavel() {

        if (energiaResponsavel_id) {

            //console.log(energiaResponsavel_id)
            //return false

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaResponsavel/${energiaResponsavel_id}`).then((result) => {
    
                            window.$('#modalEnergiaIdentificacao').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }



    function limpaDados() {

        setNome('')
        setEmail('')
        setTelefone('')
    }


    useEffect(() => {

        limpaDados()
        consultaResponsavelDet()

    }, [energiaResponsavel_id])


    return (

        <div>

                <div className="modal fade" id="modalEnergiaIdentificacao" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Identificação </h1>
                            </div>
                            <div className="modal-body">

                            <div className="row">
                            
                            
                            
                                <div className="col-md-12" >
                                    <div class="form-group" >

                                        <label className="control-label">

                                            
                                            Nome Completo *
                                            

                                        </label>
                                    
                                        <input class="form-control" input="text" value={nome} onChange={event => setNome(event.target.value)} style={{ textTransform: 'uppercase'}} maxLength="150" disabled={false} />
                                            
                                    </div>
                                </div>

                                <div className="col-md-8" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">E-mail *</label>
                                        <input class="form-control" input="text" value={email} onChange={event => setEmail(event.target.value)} style={{ textTransform: 'lowercase'}} maxLength="250" disabled={false}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <label className="control-label"><br/>DDD + Telefone *</label>
                                        <TelefoneBrasileiroInput  class="form-control" input="text" onChange={event => setTelefone(event.target.value)} value={telefone}  maxLength="150" 
                                        disabled={false}
                                        separaNono
                                        temDDD
                                        separaDDD />
                                            
                                    </div>
                                </div>

                                

                            </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => apagaResponsavel()} style={{ display: energiaResponsavel_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal


                        